
import React from 'react';
export function ModelSection() {
     return (
          <section id="model">
               <div className="wrap">
                    <div className="sec-head"><span className="sec-id">02</span>
                    <span className="mono">What we do</span><span className="rule"></span>
                         <span className="mono-s" style={{ color: "var(--dim)" }}>
                              Capability / 04
                         </span>
                    </div>
                    <div className="h2blk">
                         <h2>One partner.<br />Every route <span className="lime">to&nbsp;market.</span></h2>
                         <p className="deck">Strategy, channel management and distribution brought together under one accountable Australian
                              operator.</p>
                    </div>
                    <div className="grid4 secfoot">
                         <div className="card pan">
                              <div className="top"><span className="ix">01 / 04</span><span className="tag">CAP-01</span></div>
                              <svg className="gl" width="42" height="42" viewBox="0 0 42 42" aria-hidden="true">
                                   <rect x=".5" y=".5" width="41" height="41" fill="none" stroke="rgba(255,255,255,.16)" />
                                   <path d="M6 32 L16 20 L24 26 L36 10" fill="none" stroke="#C8F94B" stroke-width="1.4" />
                                   <circle cx="36" cy="10" r="2.6" fill="#C8F94B" />
                                   <circle cx="6" cy="32" r="2" fill="none" stroke="#5B8CFF" />
                              </svg>
                              <h3>Market entry strategy</h3>
                              <p>Positioning, range planning and a clear commercial path into Australia.</p>
                         </div>
                         <div className="card pan">
                              <div className="top"><span className="ix">02 / 04</span><span className="tag">CAP-02</span></div>
                              <svg className="gl" width="42" height="42" viewBox="0 0 42 42" aria-hidden="true">
                                   <rect x=".5" y=".5" width="41" height="41" fill="none" stroke="rgba(255,255,255,.16)" />
                                   <rect x="7" y="7" width="12" height="12" fill="none" stroke="#C8F94B" />
                                   <rect x="23" y="7" width="12" height="12" fill="none" stroke="rgba(255,255,255,.3)" />
                                   <rect x="7" y="23" width="12" height="12" fill="none" stroke="rgba(255,255,255,.3)" />
                                   <rect x="23" y="23" width="12" height="12" fill="#C8F94B" />
                              </svg>
                              <h3>Marketplace operations</h3>
                              <p>Applications, catalogue, content, pricing and day-to-day management.</p>
                         </div>
                         <div className="card pan">
                              <div className="top"><span className="ix">03 / 04</span><span className="tag">CAP-03</span></div>
                              <svg className="gl" width="42" height="42" viewBox="0 0 42 42" aria-hidden="true">
                                   <rect x=".5" y=".5" width="41" height="41" fill="none" stroke="rgba(255,255,255,.16)" />
                                   <path d="M8 21 H34" stroke="#5B8CFF" stroke-width="1.2" />
                                   <path d="M8 12 H26 M8 30 H26" stroke="rgba(255,255,255,.28)" stroke-width="1.2" />
                                   <circle cx="34" cy="21" r="3" fill="#C8F94B" />
                                   <circle cx="8" cy="12" r="2" fill="rgba(255,255,255,.5)" />
                                   <circle cx="8" cy="30" r="2" fill="rgba(255,255,255,.5)" />
                              </svg>
                              <h3>Retail &amp; wholesale distribution</h3>
                              <p>Channel development, relationships and dependable supply.</p>
                         </div>
                         <div className="card pan">
                              <div className="top"><span className="ix">04 / 04</span><span className="tag">CAP-04</span></div>
                              <svg className="gl" width="42" height="42" viewBox="0 0 42 42" aria-hidden="true">
                                   <rect x=".5" y=".5" width="41" height="41" fill="none" stroke="rgba(255,255,255,.16)" />
                                   <rect x="8" y="24" width="6" height="10" fill="rgba(255,255,255,.3)" />
                                   <rect x="18" y="18" width="6" height="16" fill="#5B8CFF" />
                                   <rect x="28" y="9" width="6" height="25" fill="#C8F94B" />
                              </svg>
                              <h3>Brand operations &amp; growth</h3>
                              <p>Performance, inventory coordination and expansion.</p>
                         </div>
                    </div>
               </div>
          </section>

     )
}